// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__u_r9e","rootSmall":"AddTileButton_rootSmall__3ONn8"};